import React from 'react';
import './HomeSection.css'

const HomeSection = ({ id, title, content }) => {
  return (
    <div id={id} className="video-section">
      {/* Background Video */}
      <video autoPlay muted loop playsInline className="video-background">
        <source src="/videos/giesen.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Section Content */}
        <div className="video-content">
            <img
                src="images/logo.png"
                alt="Decorative"
                className="bottom-0 left-0 w-100 w-100 object-cover"
            />
        </div>
    </div>
  );
};

export default HomeSection;